import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ErrorBoundary } from 'react-error-boundary'
import { ErrorPage } from 'pages/ErrorPage'
import { ThemeProvider as ComponentsThemeProvider } from '@pay-com/components'
import { OPDataProvider } from 'API/service/graphqlService.api'
import { initSentry } from 'utils'
import { App } from 'App'
import './index.css'
import './i18n/index'

const container = document.getElementById('root')

if (!container) {
  throw new Error('Root element not found')
}

initSentry()

const root = createRoot(container)

root.render(
  <StrictMode>
    <ComponentsThemeProvider>
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <OPDataProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </OPDataProvider>
      </ErrorBoundary>
    </ComponentsThemeProvider>
  </StrictMode>
)
